export const getPizza = state => state.pizza.pizza;

